var React = require('react');

function Dreadnought (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:none;stroke:#000;stroke-linecap:square;stroke-linejoin:bevel;stroke-width:2px;}")),React.createElement("title",{"key":1},"Dreadnought"),React.createElement("path",{"id":"path873","className":"cls-1","d":"M119.94,97.77H88l-24,24-24-24h-32v-32L64,9.86,119.94,65.8Z","key":2})]);
}

Dreadnought.defaultProps = {"id":"svg8","viewBox":"0 0 128 128"};

module.exports = Dreadnought;

Dreadnought.default = Dreadnought;
